module.exports = __webpack_public_path__ + "media/images/landing/ar/planning@2x-db7f66df6897d12e57726052de290d94.webp";